import { useState, useEffect } from "react";
import { Backdrop, CircularProgress, Paper, Button, Dialog, DialogActions, DialogContent, DialogTitle, Box, InputLabel, OutlinedInput, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, useMediaQuery, useTheme } from "@mui/material";

import axios from "../api/axios"

export default function InversionistaFind(props) {
    const [openDialog, setOpenDialog] = useState(false)
    const [buscar, setBuscar]=useState("")
    const [rows, setRows] = useState([]);
    const [seleccion, setSeleccion] = useState(0)
    const [procesando, setProcesando] = useState(false)

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(()=>{
        actRows();
    }, [])

    useEffect(() => {
        setOpenDialog(props.open)
    }, [props.open]);

    useEffect(()=>{
        actRows();
    }, [buscar])

    const actRows = async ()=>{
        setProcesando(true)
        let mRows = []
        try {
            const respuesta = await axios.post("inversionista/buscar", {
                buscar: buscar
            }, {
                headers: { 'Content-Type': 'application/json'}
            });
            const data = respuesta.data.lista || [];
            data.map((item)=>{
                let mId = item.id;
                let mNombre = item.nombre;
                let mApellido = item.apellido;
                let mCelular = item.celular
                mRows.push({
                    id: mId,
                    nombre: mNombre,
                    apellido: mApellido,
                    celular: mCelular
                })
            })
        } catch(error){
            console.log(error)
        }
        setRows(mRows)
        setProcesando(false)
    }

    const handleSeleccion = (cual)=>{
        setSeleccion(cual)
    }

    const objWait = () => {
        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={procesando}
                onClick={()=>{setProcesando(false)}}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        )
    }

    return (
        <Dialog
            maxWidth="md"
            open={openDialog}
            fullWidth
            fullScreen={isMobile}
            PaperProps={{
                sx: {
                    m: isMobile ? 0 : 2,
                    maxHeight: isMobile ? '100%' : '90vh'
                }
            }}
        >
            {objWait()}
            <DialogTitle sx={{
                background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                color: 'white',
                py: isMobile ? 2 : 2.5,
                px: isMobile ? 2 : 3,
                fontSize: isMobile ? '1.1rem' : '1.25rem',
                fontWeight: 700,
                textAlign: 'center',
                letterSpacing: 0.5,
                borderBottom: '3px solid #d4af37',
                textShadow: '1px 1px 2px rgba(0,0,0,0.2)'
            }}>
                Búsqueda de Inversionistas
            </DialogTitle>
            <DialogContent sx={{ p: isMobile ? 1.5 : 3 }}>
                <Box sx={{ mb: 2, mt: 1 }}>
                    <InputLabel htmlFor="buscar" sx={{ mb: 0.5, fontSize: isMobile ? '0.875rem' : '1rem' }}>
                        Buscar...
                    </InputLabel>
                    <OutlinedInput
                        id="buscar"
                        type="text"
                        value={buscar}
                        onChange={(event)=>{setBuscar(event.target.value.toUpperCase())}}
                        name="buscar"
                        autoComplete="off"
                        placeholder="Digite el nombre a buscar"
                        fullWidth
                        size={isMobile ? "small" : "medium"}
                    />
                </Box>
                <TableContainer
                    component={Paper}
                    sx={{
                        height: isMobile ? "calc(100vh - 220px)" : "400px",
                        overflow: "auto"
                    }}
                >
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{
                                    fontWeight: 700,
                                    backgroundColor: 'rgba(30, 58, 95, 0.08)',
                                    color: '#1e3a5f',
                                    fontSize: isMobile ? '0.85rem' : '0.9rem',
                                    py: isMobile ? 1.25 : 1.5,
                                    borderBottom: '2px solid rgba(30, 58, 95, 0.2)'
                                }}>
                                    Nombre
                                </TableCell>
                                {!isMobile && (
                                    <TableCell sx={{
                                        fontWeight: 700,
                                        backgroundColor: 'rgba(30, 58, 95, 0.08)',
                                        color: '#1e3a5f',
                                        fontSize: '0.9rem',
                                        py: 1.5,
                                        borderBottom: '2px solid rgba(30, 58, 95, 0.2)'
                                    }}>
                                        Apellido
                                    </TableCell>
                                )}
                                <TableCell sx={{
                                    fontWeight: 700,
                                    backgroundColor: 'rgba(30, 58, 95, 0.08)',
                                    color: '#1e3a5f',
                                    fontSize: isMobile ? '0.85rem' : '0.9rem',
                                    py: isMobile ? 1.25 : 1.5,
                                    borderBottom: '2px solid rgba(30, 58, 95, 0.2)'
                                }}>
                                    Celular
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((item,index)=>(
                                <TableRow
                                    key={item.id}
                                    hover
                                    onClick={()=>{handleSeleccion(item.id)}}
                                    selected={item.id==seleccion}
                                    onDoubleClick={()=>props.seleccion(item.id)}
                                    sx={{
                                        cursor: 'pointer',
                                        '&.Mui-selected': {
                                            backgroundColor: 'rgba(30, 58, 95, 0.15)'
                                        },
                                        '&.Mui-selected:hover': {
                                            backgroundColor: 'rgba(30, 58, 95, 0.25)'
                                        }
                                    }}
                                >
                                    <TableCell sx={{
                                        fontSize: isMobile ? '0.85rem' : '0.875rem',
                                        py: isMobile ? 1.5 : 1.25,
                                        borderBottom: '1px solid rgba(30, 58, 95, 0.1)'
                                    }}>
                                        {isMobile ? `${item.nombre} ${item.apellido}` : item.nombre}
                                    </TableCell>
                                    {!isMobile && (
                                        <TableCell sx={{
                                            py: 1.25,
                                            borderBottom: '1px solid rgba(30, 58, 95, 0.1)'
                                        }}>{item.apellido}</TableCell>
                                    )}
                                    <TableCell sx={{
                                        fontSize: isMobile ? '0.85rem' : '0.875rem',
                                        py: isMobile ? 1.5 : 1.25,
                                        borderBottom: '1px solid rgba(30, 58, 95, 0.1)'
                                    }}>
                                        {item.celular}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions sx={{
                p: isMobile ? 1.5 : 2,
                gap: 1,
                flexDirection: isMobile ? 'column' : 'row'
            }}>
                <Button
                    onClick={()=>{props.cerrar()}}
                    variant="outlined"
                    fullWidth={isMobile}
                    sx={{
                        order: isMobile ? 2 : 1,
                        color: '#1e3a5f',
                        borderColor: '#1e3a5f'
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    onClick={()=>{props.seleccion(seleccion)}}
                    variant="contained"
                    fullWidth={isMobile}
                    sx={{
                        order: isMobile ? 1 : 2,
                        background: 'linear-gradient(135deg, #1e3a5f 0%, #2c5282 100%)',
                        '&:hover': {
                            background: 'linear-gradient(135deg, #2c5282 0%, #3d6a9f 100%)'
                        }
                    }}
                >
                    Seleccionar
                </Button>
            </DialogActions>
        </Dialog>
    )
}